import { render, staticRenderFns } from "./JumpLinkButton.vue?vue&type=template&id=36d7086e&scoped=true&"
import script from "./JumpLinkButton.vue?vue&type=script&lang=js&"
export * from "./JumpLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./JumpLinkButton.vue?vue&type=style&index=0&id=36d7086e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7086e",
  null
  
)

export default component.exports